import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowRightFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowRightFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M13.69 3H9.94l5.62 7.5h-12v3h12L9.94 21h3.75l6.75-9-6.75-9Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ArrowRightFilled;